import styled from 'styled-components';

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
  width: ${props => props.labelWidth};
  justify-content: ${({ errorInLabel }) => (errorInLabel ? 'space-between' : 'unset')};
`;

export default LabelContainer;
